(function () {
  function initAccordion(root) {
    if (!root || root.dataset.lpSfInit === 'true') return;
    root.dataset.lpSfInit = 'true';

    const items = Array.from(root.querySelectorAll('[data-lp-sf-item]'));
    const DURATION = 300;
    const EASING = 'ease-in-out';
    let openItem = null;
    let animating = false;

    function setOpenState(item, isOpen) {
      const trigger = item.querySelector('[data-lp-sf-trigger]');
      item.classList.toggle('is-open', isOpen);
      if (trigger) trigger.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      if (isOpen) {
        openItem = item;
      } else if (openItem === item) {
        openItem = null;
      }
    }

    function collapseBody(item, animate) {
      const body = item.querySelector('[data-lp-sf-body]');
      if (!body || body.hidden) return Promise.resolve();

      if (!animate) {
        body.hidden = true;
        body.style.height = '';
        body.style.overflow = '';
        return Promise.resolve();
      }

      const startHeight = body.offsetHeight;
      body.style.height = startHeight + 'px';
      body.style.overflow = 'hidden';

      return new Promise((resolve) => {
        const animation = body.animate(
          { height: [startHeight + 'px', '0px'] },
          { duration: DURATION, easing: EASING }
        );

        animation.onfinish = () => {
          body.hidden = true;
          body.style.height = '';
          body.style.overflow = '';
          resolve();
        };
        animation.oncancel = resolve;
      });
    }

    function expandBody(item, animate) {
      const body = item.querySelector('[data-lp-sf-body]');
      if (!body) return Promise.resolve();

      body.hidden = false;
      const endHeight = body.scrollHeight;

      if (!animate) {
        return Promise.resolve();
      }

      body.style.height = '0px';
      body.style.overflow = 'hidden';

      return new Promise((resolve) => {
        const animation = body.animate(
          { height: ['0px', endHeight + 'px'] },
          { duration: DURATION, easing: EASING }
        );

        animation.onfinish = () => {
          body.style.height = '';
          body.style.overflow = '';
          resolve();
        };
        animation.oncancel = resolve;
      });
    }

    items.forEach((item) => {
      const trigger = item.querySelector('[data-lp-sf-trigger]');
      if (!trigger) return;

      trigger.addEventListener('click', () => {
        if (animating) return;

        const isOpen = item.classList.contains('is-open');
        const previous = openItem;
        const tasks = [];

        if (isOpen) {
          animating = true;
          setOpenState(item, false);
          collapseBody(item, true).finally(() => {
            animating = false;
          });
          return;
        }

        if (previous && previous !== item) {
          setOpenState(previous, false);
          setOpenState(item, true);
          tasks.push(collapseBody(previous, true));
          tasks.push(expandBody(item, true));
        } else {
          setOpenState(item, true);
          tasks.push(expandBody(item, true));
        }

        animating = true;
        Promise.all(tasks).finally(() => {
          animating = false;
        });
      });
    });

    const firstOpen = items.find((item) => item.dataset.lpSfOpenDefault === 'true') || items[0];
    if (firstOpen) {
      const body = firstOpen.querySelector('[data-lp-sf-body]');
      if (body) body.hidden = false;
      setOpenState(firstOpen, true);
    }
  }

  function initScope(scope) {
    if (!scope) return;
    scope.querySelectorAll('[data-lp-sf-accordion]').forEach(initAccordion);
  }

  document.addEventListener('DOMContentLoaded', () => {
    initScope(document);
  });

  document.addEventListener('shopify:section:load', (event) => {
    initScope(event.target);
  });
})();
